module.exports = __webpack_public_path__ + "img/partner-liugang.94c69020.png";